import { makeStyles } from "@mui/styles";
import { BaseThemeOptions } from "themes/base";

export const useStyles = makeStyles((theme: BaseThemeOptions) => ({
	notificationsContainer: {
		borderRadius: "10px",
		padding: "15px",
	},
}));
